const STORAGE_KEY = "walmart_pending_oauth";

export function storeWalmartPending(pendingId) {
  if (pendingId) {
    localStorage.setItem(STORAGE_KEY, pendingId);
  }
}

export function clearWalmartPending() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
}

export function peekWalmartPending() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  return params.get("walmart_pending") || localStorage.getItem(STORAGE_KEY) || null;
}

export function walmartPendingSettingsPath() {
  const pending = peekWalmartPending();
  if (!pending) return null;
  return `/settings?complete_walmart_oauth=${encodeURIComponent(pending)}`;
}

export function isOnWalmartPendingSettings() {
  if (typeof window === "undefined") return false;
  return window.location.pathname === "/settings"
    && new URLSearchParams(window.location.search).has("complete_walmart_oauth");
}

export function postAuthRedirectPath(fallback = "/dashboard") {
  return walmartPendingSettingsPath() || fallback;
}
